import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './ShareButton.css'
import { fetch } from '../utils/fetch'
import { userHasPerm } from '../utils/auth'
import { saveAlbum } from '../redux/album'
import { fetchExternalShares, setExternalShareDuration } from '../redux/share'
import { emptyStructure } from '../redux/query'
import LoadingSpinner from './LoadingSpinner'
import { ENDPOINT_SHARE_CODE } from '../constants'
import { getShareTimeLeft, getShareDaysLeft, extendShare } from '../pages/ExternalShares'

class ShareButton extends Component {
  state = {
    noDownload: false,
    fetching: false,
    fetchingPrivileged: false,
    error: null,
    createdCodes: [],
    createdPrivilegedCodes: []
  }
  componentDidMount () {
    this.props.fetchExternalShares()
  }
  fetchLink = () => {
    const { path, images, getShareCode, onFetch } = this.props
    const { noDownload } = this.state
    onFetch && onFetch()
    this.setState({
      fetching: true,
      error: null
    })
    if (path) {
      getShareCode(path, noDownload).then(this.onSuccess, this.onError)
    } else if (images) {
      this.createExternalImagesAlbum(images).then(album => {
        return getShareCode(`/album/${album.id}`, noDownload)
      }).then(this.onSuccess, this.onError)
    }
  }
  fetchPrivilegedLink = () => {
    const { path, images, getShareCode, onFetch } = this.props
    const { noDownload } = this.state
    onFetch && onFetch()
    this.setState({
      fetchingPrivileged: true,
      error: null
    })
    if (path) {
      let yearInSecs = 31536000;
      getShareCode(path, noDownload, true, yearInSecs).then(this.onSuccess, this.onError)
    } else if (images) {
      this.createExternalImagesAlbum(images).then(album => {
        return getShareCode(`/album/${album.id}`, noDownload)
      }).then(this.onSuccess, this.onError)
    }
  }
  createExternalImagesAlbum = images => {
    const { name, saveAlbum } = this.props
    const data = {
      name: `Shared Images From ${name}`,
      user_id: 0,
      presentation_type: null,
      presentation_speed: null,
      presentation_transition: null,
      presentation_sort: null
    }
    const structure = {
      ...emptyStructure,
      include: images
    }
    return saveAlbum(data, structure, undefined, false)
  }
  onSuccess = data => {
    let newState = {
      fetching: false,
      fetchingPrivileged: false
    }
    if (data.records.share_creator_perms == true) {
      newState.createdPrivilegedCodes = this.state.createdPrivilegedCodes.concat(data.records)
    } else {
      newState.createdCodes = this.state.createdCodes.concat(data.records)
    }

    this.setState(newState);
  }
  onError = error => {
    this.setState({
      error,
      fetching: false,
      fetchingPrivileged: false
    })
  }
  onLinkClick = e => {
    e.target.setSelectionRange(0, 9999)
  }
  onExtendShare = (share, timeLeft) => {
    extendShare(share, timeLeft, this.props.setExternalShareDuration)
    this.setState({
      createdCodes: this.state.createdCodes.map(s => {
        if (s.id === share.id) {
          return { ...s, duration: s.duration + 604800 }
        }
        return s
      })
    })
  }
  onSuspendShare = (share) => {
    this.props.setExternalShareDuration(share.external_id, null)
    this.setState({
      createdCodes: this.state.createdCodes.map(s => {
        if (s.id === share.id) {
          return { ...s, duration: null }
        }
        return s
      })
    })
  }
  getExpiryText (share) {
    if (share) {
      const timeLeft = getShareTimeLeft(share)
      return (
        <p className={classNames.info}>
          {timeLeft === Infinity &&
            'Link will never expire'
          }
          {timeLeft !== 0 && timeLeft !== Infinity &&
            'Link will expire in ' + getShareDaysLeft(timeLeft)
          }
          {timeLeft === 0 &&
            'Link has expired'
          }
          {this.props.canExtend &&
            <button onClick={() => this.onExtendShare(share, timeLeft)}>
              {timeLeft === Infinity ? 'Reset' : 'Extend'}
            </button>
          }
          {this.props.canSuspend &&
            <button onClick={() => this.onSuspendShare(share)} disabled={timeLeft === Infinity}>
              Suspend
            </button>
          }
        </p>
      )
    }
    return (
      <p className={classNames.info}>
        Links will expire after one week
      </p>
    )
  }
  renderButton () {
    const { fetching, noDownload } = this.state
    return (
      <div>
        <button onClick={this.fetchLink} className={classNames.button} disabled={fetching}>
          { fetching ? 'Generating public link…' : 'Generate public link' }
        </button>
        {!this.props.hideDownloadToggle &&
          <label className={classNames.downloadLabel}>
            <input
              type='checkbox'
              checked={noDownload}
              onChange={() => this.setState({ noDownload: !noDownload })}
              disabled={fetching}
            />
            Prevent downloads
          </label>
        }
      </div>
    )
  }
  renderPrivilegedButton () {
    const { fetchingPrivileged } = this.state
    return (
      <button onClick={this.fetchPrivilegedLink} className={classNames.button} disabled={fetchingPrivileged}>
        { fetchingPrivileged ? 'Generating Orchestra code…' : 'Generate Orchestra code' }
      </button>
    )
  }
  renderCode (code, type) {
    const { protocol, host } = window.location
    if (type == 'regular') {
      return (
        <input
          type='text'
          className={classNames.code}
          value={`${protocol}//${host}/share/${code}`}
          onClick={this.onLinkClick}
          readOnly
        />
      )
    } else if (type == 'orchestra') {
      return (
        <input
          type='text'
          className={classNames.orchestraCode}
          value={code}
          onClick={this.onLinkClick}
          readOnly
        />
      )
    }
  }
  renderShare = share => {
    let codeType = share.share_creator_perms ? 'orchestra' : 'regular';
    console.log(share)
    return (
      <div className={classNames.share}>
        {this.renderCode(share.external_id, codeType)}
        {this.getExpiryText(share)}
      </div>
    )
  }
  render () {
    if (this.props.fetchingExisting) {
      return (
        <div className={classNames.wrapper} style={this.props.style}>
          <LoadingSpinner />
        </div>
      )
    }
    const { existingShares } = this.props
    const { regular, privileged } = existingShares
    let privilegedSection;
    if (this.props.allowPrivileged) {
      privilegedSection = (
        <div>
          <br></br>
          <h3>Orchestra Codes</h3>
          {privileged.map(this.renderShare)}
          {this.state.createdPrivilegedCodes.map(this.renderShare)}
          {this.renderPrivilegedButton()}
        </div>
      )
    }
    return (
      <div className={classNames.wrapper} style={this.props.style}>
        {regular.map(this.renderShare)}
        {this.state.createdCodes.map(this.renderShare)}
        {this.renderButton()}
        {this.getExpiryText()}

        {privilegedSection}
      </div>
    )
  }
}

const mapStateToProps = ({ auth, share }, { path }) => ({
  fetchingExisting: share.external.fetching,
  existingShares: getExistingShares(share.external.data, path, auth),
  getShareCode: (path, noDownload, privileged, duration) => fetch(ENDPOINT_SHARE_CODE, {
    token: auth.token,
    query: {
      path,
      no_download: noDownload,
      share_creator_perms: privileged || false,
      duration: duration
    }
  }),
  name: auth.user.name,
  canExtend: userHasPerm(auth.user, 'extend_external_share') || userHasPerm(auth.user, 'admin'),
  canSuspend: userHasPerm(auth.user, 'admin')
})

function getExistingShares (data, path, auth) {
  console.log(data);
  if (!data) {
    return {regular: [], privileged: [] };
  }
  let all =  data.filter(share => {
    return share.path === path && share.user_id === auth.user.id
  });
  let regular = all.filter(share => {
    return share.share_creator_perms != true;
  })
  let privileged = all.filter(share => {
    return share.share_creator_perms;
  })

  return { regular: regular, privileged: privileged };
}

const mapDispatchToProps = {
  saveAlbum,
  fetchExternalShares,
  setExternalShareDuration
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareButton)



// WEBPACK FOOTER //
// ./src/components/ShareButton.js